// "use strict";


const wpel = require('./include/_wpel')();

// require('bootstrap-sass');

import './include/_gmap';

import VendorCommonCtrl from './vendor/_common';
import CommonCtrl from './include/_common';
import NaviCtrl from './include/_gnavi';
import FrontCtrl from './include/_front';
import OffcanvasCtrl from './include/_offcanvas';
import WP_EditBar from './include/_wp-edit-bar';

const common = new CommonCtrl();

const gnavi = new NaviCtrl('#globalNavi');
gnavi.init();

const front = new FrontCtrl('.slider__container');
front.init();

const offcanvas = new OffcanvasCtrl('[data-toggle="offcanvas"]');
offcanvas.init();

const wpEditbar = new WP_EditBar();
wpEditbar.init();


const vendorCommon = new VendorCommonCtrl();
vendorCommon.init();